import { documentIsBeingEdited, getLatestFinishedCommitData, getLatestUnfinishedCommit } from 'lib/documentHandling';
import { Dialog, FlatButton, RaisedButton } from 'material-ui';
import { func, node, bool, string, arrayOf, object, oneOfType, any, number } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import EditableV2 from 'routes/Documents/containers/EditableV2';
import { isDocumentDone } from '../../utils';

const customContentStyle = {
  width: '80%',
  maxWidth: 'none',
};

class FormDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: this.props.dialogOpen,
    };
  }

  setDialogOpen = dialogOpen => this.setState({ dialogOpen });

  componentDidUpdate(prevProps) {
    if (this.props.dialogOpen !== this.state.dialogOpen) {
      this.setDialogOpen(this.props.dialogOpen);
    }
    if (this.props.infoComponent && !prevProps.infoComponent) {
      // Scroll to top when infoComponent is opened
      const dialogElement = document.getElementById('formDialogPaper');
      const contentElement = path(['children', 1], dialogElement);
      contentElement && contentElement.scrollTo(0, 0);
    }
  }

  cancel = (editingDocument, editedCommit) => {
    if (editingDocument && editedCommit) {
      this.props.cancelCallback(editingDocument, editedCommit.commitId);
    }
  };
  confirm = (editingDocument, editedCommit, currentValues) => {
    if (editingDocument && editedCommit) {
      this.props.confirmCallback(editingDocument, editedCommit.commitId, currentValues);
    }
  };
  close = () => {
    this.props.closeCallback();
  };

  render() {
    const { form, type, documents, infoComponent, editingId, viewingId, fm } = this.props;

    // Sort by createDate so that newest created document can be found first
    const sortedDocuments = documents ? documents.sort((d1, d2) => d2.createDate - d1.createDate) : [];

    const editingDocument =
      !viewingId &&
      sortedDocuments.find(d => {
        if (d.documentType === type) {
          if (editingId) {
            if (editingId === 'newDocument') {
              return documentIsBeingEdited(d);
            }
            return d.documentId === editingId && documentIsBeingEdited(d);
          }
        }
        return null;
      });
    const editedCommit = editingDocument ? getLatestUnfinishedCommit(editingDocument) : null;
    const viewingDocument = sortedDocuments.find(d => d.documentType === type && d.documentId === viewingId);

    return (
      <Dialog
        id="dialog"
        title={<h1>{fm(`${type}.title`)}</h1>}
        open={this.state.dialogOpen}
        contentStyle={customContentStyle}
        autoScrollBodyContent
        paperProps={{ id: 'formDialogPaper' }}
        actions={
          infoComponent
            ? [<RaisedButton label={fm('onlineRehabilitation.dialog.close')} onClick={() => this.close()} primary />]
            : viewingDocument
              ? [<RaisedButton label={fm('onlineRehabilitation.dialog.close')} onClick={() => this.close()} primary />]
              : [
                  <FlatButton
                    label={fm('onlineRehabilitation.dialog.cancel')}
                    onClick={() => this.cancel(editingDocument, editedCommit)}
                  />,
                  <RaisedButton
                    label={fm('onlineRehabilitation.dialog.confirm')}
                    onClick={() => this.confirm(editingDocument, editedCommit, this.props.currentFormValues)}
                    primary
                    disabled={!isDocumentDone(editedCommit, type)}
                  />,
                ]
        }
      >
        {infoComponent ? (
          <div id="test">{infoComponent}</div>
        ) : form && editingDocument ? (
          <EditableV2
            documentId={editingDocument.documentId}
            moduleName={editingDocument.documentType}
            editedCommit={editedCommit}
            isDialog
          >
            {React.createElement(form)}
          </EditableV2>
        ) : form && viewingDocument ? (
          <div>
            {React.createElement(form, {
              editing: false,
              formValues: getLatestFinishedCommitData(viewingDocument),
            })}
          </div>
        ) : (
          <div />
        )}
      </Dialog>
    );
  }
}

FormDialog.propTypes = {
  dialogOpen: bool,
  type: string,
  form: oneOfType([node, any]),
  cancelCallback: func,
  confirmCallback: func,
  closeCallback: func,
  documents: arrayOf(object),
  infoComponent: node,
  editingId: string,
  viewingId: string,
  currentFormValues: oneOfType([object, number]), // Object or null
  fm: func,
};

// We fetch form values here because saving is handled outside the toolbar component.
// New finish commit requires us to pass final values.
const mapStateToProps = (state, ownProps) => {
  if (ownProps.type && state.form && !ownProps.viewingId) {
    return { currentFormValues: getFormValues(ownProps.type)(state) };
  }
  return { currentFormValues: null };
};

export default connect(mapStateToProps)(FormDialog);
